



































import { Vue, Component, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { validateAll, setStore, getStore, manglingFormatCardNumber } from '@/utils/utils'
import { SelectedPicker, ValidateField, CountingButton } from '@/components'
import axios from 'axios'
import baseURL from '@/api/api.js'
const accountManage = namespace('accountManage')
const commonModules = namespace('commonModules')
import * as api from '@/api/accountManage'

@Component({
  name: 'changeBank',
  components: {
    'validate-field': ValidateField,
  },
})
export default class changeBank extends Vue {
  @accountManage.Action bankListFN: any
  @accountManage.State bankList: any
  @accountManage.Action bankCardBind: any
  @accountManage.Action getAccNoName
  iconData: object = {}
  radio: string = '1'
  oldDefaultAddNo: string = ''
  updateAddNoPra: any = {}
  pageType: string = 'add' // 展示页面
  accNoNameShow: string = '' // 返显银行卡名称
  //   ll----------------------------
  @commonModules.Action onSendMsg
  @commonModules.Action checkVerCode

  msgDisabled: Boolean = true // 验证码
  time: Number = 0
  counts: string = 's'
  isSend: Boolean = false
  checked: boolean = false
  verCodeCheck: string = '' // 验证码校验
  imgSrc: string = ''
  bankNameList: any = []
  // ll------------------
  created() {
    let that = this
    api
      .bankList({
        custId: getStore('userInfo') ? JSON.parse(getStore('userInfo')).custId : '',
      })
      .then((res) => {
        if (res['code'] == 200) {
          return res.data
        }
      })
      .then((data1) => {
        for (let i = 0; i < data1.length; i++) {
          if (data1[i].isDefault == '01') this.updateAddNoPra.defAccNo = data1[i].accNo
          data1[i]['checked'] = false
          data1[i]['hiddenAccNo'] = manglingFormatCardNumber(data1[i]['accNo'])
          // 处理图片流
          if (data1[i]['bankCode']) {
            this.getAccnobackImage1(data1[i]['bankCode'], data1[i]['bankCode']).then(
              (value: any) => {
                for (let [key, val] of Object.entries(value)) {
                  if (key == data1[i]['bankCode']) {
                    this.$set(data1[i], 'imgUrl', val)
                  }
                }
              }
            )
          } else {
            data1[i]['imgUrl'] = ''
          }
          this.bankNameList = data1
        }
      })
      .catch((error) => {})

    // this.bankListFN({ custId: JSON.parse(getStore('userInfo')).custId })
  }
  @Watch('bankNameList', { immediate: true })
  onChange(val) {
    for (var i = 0, len = val.length; i < len; i++) {
      if (val[i]['isDefault'] == '01') {
        this.radio = i + 1 + ''
        this.oldDefaultAddNo = val[i].accNo
      }
    }
  }

  confirmHandel(type) {
    if (type == 'confirm') {
      let param = {
        ...this.updateAddNoPra,
      }
      //   this.$toast.loading('正在修改')
      this.$toast.loading({
        message: '正在修改',
        duration: 0,
        forbidClick: true,
      })
      this.bankCardBind(param).then((res) => {
        if (res['code'] == 200) {
          this.$toast.clear()
          this.$router.go(-1)
        }
      })
    } else {
      this.$router.go(-1)
    }
  }
  checkClick(val) {
    // let userInfo = getStore("userInfo") ? JSON.parse(getStore("userInfo")) : {};
    let param = {
      custId: getStore('userInfo') ? JSON.parse(getStore('userInfo')).custId : '', //用户id
      optFlag: 'upd', //新增-add，解绑-del，修改默认卡-upd
      accNo: this.oldDefaultAddNo, //银行卡号
      passWord: '', //支付密码（MD5加密一次后）
      verCode: '', //验证码
      mobile: val.mobile, //预留手机号
      defAccNo: val.accNo, // 修改后的银行卡号
      credId: getStore('userInfo') ? JSON.parse(getStore('userInfo')).credId : '',
    }
    this.updateAddNoPra = { ...param }
  }

  private getAccnobackImage1 = async (params: any, index: any) => {
    let arrImg: any = {}
    await axios
      .get(`${baseURL.baseURL}/h5/getBankLogo?bankCode=${params}`, {
        responseType: 'arraybuffer',
      })
      .then((res: any) => {
        return (
          'data:image/png;base64,' +
          btoa(new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), ''))
        )
      })
      .then((data) => {
        arrImg[index] = data
      })
      .catch((ex) => {
        console.error(ex)
      })
    return arrImg
  }
}
